(function() {
  var SCROLL_THRESHOLD = 80;
  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 180;

  function init(hdr) {
    if (!hdr || hdr.dataset.snhInited === '1') return;
    hdr.dataset.snhInited = '1';

    // Only measure while the header is full height, since it shrinks on scroll.
    var spacer = document.querySelector('.snh-spacer');
    if (spacer) {
      var syncSpacer = function() {
        if (hdr.classList.contains('snh--scrolled')) return;
        spacer.style.height = hdr.offsetHeight + 'px';
      };
      syncSpacer();
      window.addEventListener('resize', syncSpacer);
      window.addEventListener('load', syncSpacer);
      hdr._snhSpacerSync = syncSpacer;
      if (typeof ResizeObserver === 'function') {
        var ro = new ResizeObserver(syncSpacer);
        ro.observe(hdr);
        hdr._snhSpacerRO = ro;
      }
    }

    var cartBtn = hdr.querySelector('[data-snh-cart-toggle]');
    if (cartBtn) {
      cartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('sannico:cart:open'));
      });
    }

    var favBtn = hdr.querySelector('[data-snh-fav-toggle]');
    if (favBtn) {
      favBtn.addEventListener('click', function(e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('sannico:cart:open', { detail: { tab: 'wishlist' } }));
      });
    }

    var burger = hdr.querySelector('.snh__burger');
    var drawer = hdr.querySelector('.snh__drawer');
    var drawerClose = hdr.querySelector('.snh__drawer-close');
    var backdrop = hdr.querySelector('[data-snh-backdrop]');
    var searchToggle = hdr.querySelector('[data-snh-search-toggle]');
    var searchPanel = hdr.querySelector('[data-snh-search]');
    var searchClose = hdr.querySelector('[data-snh-search-close]');
    var searchInput = searchPanel && searchPanel.querySelector('input[type="search"]');
    var megaPanel = hdr.querySelector('[data-snh-mega]');
    var megaItems = hdr.querySelectorAll('.snh__nav-item--mega');
    var openTimer = null, closeTimer = null;

    function clearTimers() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }
    function setMegaExpanded(item, on) {
      var link = item && item.querySelector('.snh__nav-link');
      if (link) link.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function openMega(item) {
      clearTimers();
      megaItems.forEach(function(it) {
        it.classList.remove('snh__nav-item--on');
        setMegaExpanded(it, false);
      });
      item.classList.add('snh__nav-item--on');
      setMegaExpanded(item, true);
      if (!megaPanel) return;
      var key = item.getAttribute('data-mega');
      var panels = megaPanel.querySelectorAll('[data-mega-panel]');
      var hasPanel = false;
      panels.forEach(function(p) {
        var match = p.getAttribute('data-mega-panel') === key;
        p.hidden = !match;
        if (match) hasPanel = true;
      });
      if (!hasPanel) { closeMega(); return; }
      megaPanel.hidden = false;
      hdr.classList.add('snh--mega-open');
      requestAnimationFrame(function() { megaPanel.classList.add('snh__mega--on'); });
    }
    function closeMega() {
      clearTimers();
      if (!megaPanel) return;
      megaPanel.classList.remove('snh__mega--on');
      hdr.classList.remove('snh--mega-open');
      megaItems.forEach(function(it) {
        it.classList.remove('snh__nav-item--on');
        setMegaExpanded(it, false);
      });
      setTimeout(function() { megaPanel.hidden = true; }, 220);
    }
    function scheduleOpen(item) {
      clearTimers();
      openTimer = setTimeout(function() { openMega(item); }, OPEN_DELAY);
    }
    function scheduleClose() {
      clearTimers();
      closeTimer = setTimeout(closeMega, CLOSE_DELAY);
    }

    megaItems.forEach(function(item) {
      item.addEventListener('mouseenter', function() { scheduleOpen(item); });
      item.addEventListener('focusin', function() { scheduleOpen(item); });
      item.addEventListener('mouseleave', scheduleClose);
    });
    if (megaPanel) {
      megaPanel.addEventListener('mouseenter', clearTimers);
      megaPanel.addEventListener('mouseleave', scheduleClose);
    }

    // Tabbing out closes the menu, like moving the pointer away.
    hdr.addEventListener('focusout', function(e) {
      if (!megaPanel || megaPanel.hidden) return;
      var next = e.relatedTarget;
      if (next && (megaPanel.contains(next) || isInMegaItem(next))) return;
      scheduleClose();
    });
    function isInMegaItem(node) {
      for (var i = 0; i < megaItems.length; i++) {
        if (megaItems[i].contains(node)) return true;
      }
      return false;
    }

    function openDrawer() {
      if (!drawer || !backdrop) return;
      drawer.hidden = false; backdrop.hidden = false;
      document.body.style.overflow = 'hidden';
      burger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function() {
        drawer.classList.add('snh__drawer--on');
        backdrop.classList.add('snh__backdrop--on');
      });
    }
    function closeDrawer() {
      if (!drawer || !backdrop) return;
      drawer.classList.remove('snh__drawer--on');
      backdrop.classList.remove('snh__backdrop--on');
      document.body.style.overflow = '';
      burger.setAttribute('aria-expanded', 'false');
      setTimeout(function() { drawer.hidden = true; backdrop.hidden = true; }, 280);
    }
    if (burger) burger.addEventListener('click', openDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    var searchReturnFocus = null;
    function openSearch() {
      if (!searchPanel) return;
      searchReturnFocus = document.activeElement;
      searchPanel.hidden = false;
      document.body.style.overflow = 'hidden';
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
      if (window.sannicoTrapFocus) window.sannicoTrapFocus(searchPanel);
      requestAnimationFrame(function() {
        searchPanel.classList.add('snh__search--on');
        if (searchInput) searchInput.focus();
      });
    }
    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.classList.remove('snh__search--on');
      document.body.style.overflow = '';
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
      if (window.sannicoReleaseFocus) window.sannicoReleaseFocus(searchPanel);
      setTimeout(function() { searchPanel.hidden = true; }, 220);
      // Send focus back where it came from, not to the top of the document.
      if (searchReturnFocus && searchReturnFocus.focus) searchReturnFocus.focus();
      searchReturnFocus = null;
    }
    if (searchToggle) searchToggle.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    function onKey(e) {
      if (e.key === 'Escape') {
        if (searchPanel && searchPanel.classList.contains('snh__search--on')) closeSearch();
        else if (drawer && drawer.classList.contains('snh__drawer--on')) closeDrawer();
        else if (megaPanel && megaPanel.classList.contains('snh__mega--on')) closeMega();
      }
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        openSearch();
      }
    }
    document.addEventListener('keydown', onKey);

    function onDocClick(e) {
      if (!megaPanel || !megaPanel.classList.contains('snh__mega--on')) return;
      if (!hdr.contains(e.target)) closeMega();
    }
    document.addEventListener('click', onDocClick);

    var scrolled = false;
    function onScroll() {
      var s = window.scrollY > SCROLL_THRESHOLD;
      if (s !== scrolled) {
        scrolled = s;
        hdr.classList.toggle('snh--scrolled', scrolled);
      }
      if (megaPanel && megaPanel.classList.contains('snh__mega--on')) closeMega();
    }
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    function popBadge(node) {
      node.classList.remove('snh__badge--pop');
      void node.offsetWidth;
      node.classList.add('snh__badge--pop');
    }

    function readWishlistCount() {
      try { return (JSON.parse(localStorage.getItem('snc:wishlist')) || []).length; } catch (e) { return 0; }
    }

    function setFavCount(count, pop) {
      var node = hdr.querySelector('[data-snh-fav-count]');
      var btn = hdr.querySelector('[data-snh-fav-toggle]');
      if (!node) return;
      var prev = node.hidden ? 0 : parseInt(node.textContent, 10) || 0;
      node.textContent = count;
      node.hidden = count === 0;
      if (btn) btn.classList.toggle('snh__icon--fav-on', count > 0);
      if (pop && count > prev) popBadge(node);
    }

    function onWishlistChange(e) {
      var count = e.detail && typeof e.detail.count === 'number' ? e.detail.count : readWishlistCount();
      setFavCount(count, true);
    }

    function onStorage(e) {
      if (e.key === 'snc:wishlist') setFavCount(readWishlistCount(), false);
    }

    setFavCount(readWishlistCount(), false);
    document.addEventListener('sannico:wishlist:change', onWishlistChange);
    window.addEventListener('storage', onStorage);

    function onCartRefresh(e) {
      var count = (e.detail && typeof e.detail.item_count === 'number') ? e.detail.item_count : null;
      if (count == null) return;
      var node = hdr.querySelector('[data-snh-cart-count]');
      if (!node) return;
      var prev = node.hidden ? 0 : parseInt(node.textContent, 10) || 0;
      node.textContent = count;
      node.hidden = count === 0;
      if (count > prev) popBadge(node);
    }
    document.addEventListener('cart:refresh', onCartRefresh);

    hdr._snhTeardown = function() {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('scroll', onScroll);
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('cart:refresh', onCartRefresh);
      document.removeEventListener('sannico:wishlist:change', onWishlistChange);
      window.removeEventListener('storage', onStorage);
      if (hdr._snhSpacerSync) {
        window.removeEventListener('resize', hdr._snhSpacerSync);
        window.removeEventListener('load', hdr._snhSpacerSync);
      }
      if (hdr._snhSpacerRO) hdr._snhSpacerRO.disconnect();
    };
  }

  function bootstrap() {
    document.querySelectorAll('[data-snh-root]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var hdr = e.target.querySelector('[data-snh-root]');
    if (hdr) init(hdr);
  });
  document.addEventListener('shopify:section:unload', function(e) {
    var hdr = e.target.querySelector('[data-snh-root]');
    if (hdr && typeof hdr._snhTeardown === 'function') hdr._snhTeardown();
  });
})();

// Predictive search: live product suggestions inside the search overlay.
(function() {
  var DEBOUNCE = 220;

  var STR = (window.sannicoStrings && window.sannicoStrings.search) || {};
  function str(key, fallback, value) {
    var s = STR[key] || fallback;
    return value == null ? s : s.replace('%s', value);
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2);
  }

  function announce(count, query) {
    var status = document.querySelector('[data-snh-search-status]');
    if (!status) return;
    status.textContent = count
      ? str('results_count', '%s results', count)
      : str('no_results', 'Nothing found for "%s".', query);
  }

  function render(box, hints, data, query) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    announce(products.length, query);
    if (!products.length) {
      box.innerHTML = '<p class="snh__sr-empty">' + esc(str('no_results', 'Nothing found for "%s". Try a brand or product type.', query)) + '</p>';
      box.hidden = false;
      if (hints) hints.hidden = false;
      return;
    }
    var rows = products.map(function(p) {
      var img = p.featured_image && p.featured_image.url;
      var onSale = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price);
      return '<li class="snh__sr-item"><a href="' + esc(p.url) + '">'
        + (img
          ? '<img class="snh__sr-thumb" src="' + esc(img) + '&width=112" alt="" width="56" height="56" loading="lazy">'
          : '<span class="snh__sr-thumb snh__sr-thumb--blank">' + esc((p.title || '?').charAt(0)) + '</span>')
        + '<span class="snh__sr-meta">'
        + '<span class="snh__sr-vendor">' + esc(p.vendor || '') + '</span>'
        + '<span class="snh__sr-title">' + esc(p.title) + '</span>'
        + '<span class="snh__sr-price' + (onSale ? ' snh__sr-price--sale' : '') + '">' + money(p.price)
        + (onSale ? '<span class="was">' + money(p.compare_at_price_max) + '</span>' : '')
        + '</span></span></a></li>';
    }).join('');
    box.innerHTML = '<ul class="snh__sr-grid">' + rows + '</ul>'
      + '<a class="snh__sr-all" href="/search?q=' + encodeURIComponent(query) + '">' + esc(str('see_all', 'See all results'))
      + '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 5l7 7-7 7"/></svg></a>';
    box.hidden = false;
    if (hints) hints.hidden = true;
  }

  function init() {
    var input = document.querySelector('[data-snh-search-input]');
    var box = document.querySelector('[data-snh-search-results]');
    if (!input || !box) return;
    var hints = document.querySelector('[data-snh-search-hints]');
    var timer = null;
    var ctrl = null;

    input.addEventListener('input', function() {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) {
        box.hidden = true;
        box.innerHTML = '';
        if (hints) hints.hidden = false;
        return;
      }
      timer = setTimeout(function() {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        var url = '/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: ctrl.signal })
          .then(function(r) { return r.json(); })
          .then(function(data) { render(box, hints, data, q); })
          .catch(function(err) { if (err.name !== 'AbortError') box.hidden = true; });
      }, DEBOUNCE);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function() {
  function init() {
    var nav = document.querySelector('.snh__nav-inner');
    var bar = document.querySelector('[data-snh-nav-cursor]');
    if (!nav || !bar) return;

    function moveTo(link) {
      var x = link.getBoundingClientRect().left - nav.getBoundingClientRect().left;
      bar.style.transform = 'translateX(' + Math.round(x) + 'px)';
      bar.style.width = Math.round(link.getBoundingClientRect().width) + 'px';
      bar.style.opacity = '1';
    }

    function rest() {
      var here = nav.querySelector('.snh__nav-item--here .snh__nav-link');
      if (here) moveTo(here);
      else bar.style.opacity = '0';
    }

    nav.querySelectorAll('.snh__nav-link, .snh__nav-wc').forEach(function(link) {
      link.addEventListener('mouseenter', function() { moveTo(link); });
      link.addEventListener('focus', function() { moveTo(link); });
    });
    nav.addEventListener('mouseleave', rest);
    window.addEventListener('resize', rest);
    rest();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
